import { render } from "./ItemsGroupView.vue?vue&type=template&id=c1154628&ts=true"
import script from "./ItemsGroupView.vue?vue&type=script&lang=ts"
export * from "./ItemsGroupView.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__